export default "__VITE_ASSET__Cf5AZUhR__"